import { useNavigate } from "react-router";
import { Button } from "react-bootstrap";

export default function NotFound() {
  // *************
  // TO DO

  // Style
  // *************

  const navigate = useNavigate();
  return (
    <section className="chroma-section">
      <h1>404</h1>
      <section className="section-content">
        <p>Page not found</p>
        <Button onClick={() => navigate(-1)}>Back</Button>
        <Button onClick={() => navigate("/dashboard")}>Home</Button>
        <section className="sub-section">I am a sub section</section>
      </section>
    </section>
  );
}
